import HTTPRequest from '../index'

const apiLinkLineByLiff = '/api/v2/users/link-line-liff'
const apiUnlinkLine = '/api/v2/users/unlink-line'

class Line extends HTTPRequest {
  linkLineByLiff(data: { id_token: string }) {
    return this.put(`${apiLinkLineByLiff}`, data)
  }

  unlinkLine() {
    return this.post(`${apiUnlinkLine}`)
  }
}

export default new Line()
